/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AiProcessRequest { 
    text: string;
    mode: AiProcessRequest.ModeEnum;
}
export namespace AiProcessRequest {
    export type ModeEnum = 'clean' | 'summary';
    export const ModeEnum = {
        Clean: 'clean' as ModeEnum,
        Summary: 'summary' as ModeEnum
    };
}


